/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseTeaserTileFragment, TeaserTileFragment, FullTeaserTileFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile';

/**
 * Get a single TeaserTile by ID (base - scalars only)
 */
export const getBaseTeaserTileById = gql`
  ${BaseTeaserTileFragment}

  query GetBaseTeaserTileById($id: String!, $locale: String!, $preview: Boolean) {
    teaserTile(id: $id, locale: $locale, preview: $preview) {
      ...BaseTeaserTileFragment
    }
  }
`;

/**
 * Get a single TeaserTile by ID (standard - 1 level deep)
 */
export const getTeaserTileById = gql`
  ${TeaserTileFragment}

  query GetTeaserTileById($id: String!, $locale: String!, $preview: Boolean) {
    teaserTile(id: $id, locale: $locale, preview: $preview) {
      ...TeaserTileFragment
    }
  }
`;

/**
 * Get a single TeaserTile by ID (full - 2 levels deep)
 */
export const getFullTeaserTileById = gql`
  ${FullTeaserTileFragment}

  query GetFullTeaserTileById($id: String!, $locale: String!, $preview: Boolean) {
    teaserTile(id: $id, locale: $locale, preview: $preview) {
      ...FullTeaserTileFragment
    }
  }
`;

/**
 * Get all TeaserTile entries with pagination (base - scalars only)
 */
export const getBaseTeaserTiles = gql`
  ${BaseTeaserTileFragment}

  query GetBaseTeaserTiles(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TeaserTileOrder]
    $where: TeaserTileFilter
    $preview: Boolean
  ) {
    teaserTileCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseTeaserTileFragment
      }
    }
  }
`;

/**
 * Get all TeaserTile entries with pagination (standard - 1 level deep)
 */
export const getTeaserTiles = gql`
  ${TeaserTileFragment}

  query GetTeaserTiles(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TeaserTileOrder]
    $where: TeaserTileFilter
    $preview: Boolean
  ) {
    teaserTileCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...TeaserTileFragment
      }
    }
  }
`;

/**
 * Get all TeaserTile entries with pagination (full - 2 levels deep)
 */
export const getFullTeaserTiles = gql`
  ${FullTeaserTileFragment}

  query GetFullTeaserTiles(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [TeaserTileOrder]
    $where: TeaserTileFilter
    $preview: Boolean
  ) {
    teaserTileCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullTeaserTileFragment
      }
    }
  }
`;
